import ReactDOM from "react-dom";
import { Button, Tooltip } from "antd";
import { FileTextOutlined, PictureOutlined } from "@ant-design/icons";
import styled from "styled-components";
import DraggableOverlay from "./DraggableOverlay";
import { useNotesAndPictures } from "../../../hooks/useNotesAndPictures";

// ---------------------------------------------------------------------------
// Shared icon-button style matching HighlightPanel
// ---------------------------------------------------------------------------
const IconButton = styled(Button)`
  height: 34px;
  min-width: 34px;
  padding: 0;
  border-radius: 8px;
  font-size: 17px;

  background: #393e46 !important;
  color: #eeeeee !important;
  border: 1px solid #8e1616 !important;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  &:hover:not(:disabled) {
    background: #222831 !important;
    border-color: #8e1616 !important;
    box-shadow: 0 0 0 2px rgba(142, 22, 22, 0.2);
  }
`;

// Hidden on mobile (≤768 px) – mirrors the HighlightGroup breakpoint
const PanelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    display: none;
  }
`;

// ---------------------------------------------------------------------------
// NotesPanel – the two toolbar buttons
// ---------------------------------------------------------------------------
export default function NotesPanel() {
  const { items, addItem, removeItem, updateItem } = useNotesAndPictures();

  return (
    <>
      <PanelWrapper>
        <Tooltip title="Add note">
          <IconButton
            icon={<FileTextOutlined />}
            aria-label="Add note"
            onClick={() => addItem("note")}
          />
        </Tooltip>
        <Tooltip title="Add picture">
          <IconButton
            icon={<PictureOutlined />}
            aria-label="Add picture"
            onClick={() => addItem("picture")}
          />
        </Tooltip>
      </PanelWrapper>

      {ReactDOM.createPortal(
        <>
          {items.map((item) => (
            <DraggableOverlay
              key={item.id}
              item={item}
              onClose={() => removeItem(item.id)}
              onChange={(patch) => updateItem(item.id, patch)}
            />
          ))}
        </>,
        document.body,
      )}
    </>
  );
}
